import React from "react";
import { useTranslation } from "react-i18next";
import { formatBoavistaData } from "../../../../utils/utils";

function BoavistaSummaryTotal(props) {

    const { description, total, secondDescription } = props

    const { t } = useTranslation()

    return (
        <div>
            <div 
                className={["normalText","analysisCardSummaryLargeSize","analysisCardSummaryColor", "alignCenter"].join(" ")}
                style={{padding:"10px"}}
            >
                {formatBoavistaData(description, t(total))}
            </div>
            <div className={["normalText","normalMediumSize","analysisCardSummaryColor", "alignCenter"].join(" ")}>
                {t(description)}
            </div>
            {secondDescription&&
                <div className={["normalText","normalMediumSize","analysisCardSummaryColor", "alignCenter"].join(" ")}>
                    {t(secondDescription)}
                </div>}
        </div>
    )
}


export default BoavistaSummaryTotal